///jacques-andre-editeur\proshop-v2\frontend\src\slices\booksApiSlice.js
import { BOOKS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const booksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBooks: builder.query({
      query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage }) => ({
        url: BOOKS_URL,
        params: { keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),

    getBookList: builder.query({
      query: ({ keyword, parPage, pageNumber }) => ({
        url: `${BOOKS_URL}/list`,
        params: { keyword, parPage, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),    
    
    getBookDetailsById: builder.query({
      query: ({ bookId, isAdminSpace }) => ({
        url: `${BOOKS_URL}/${bookId}`,
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, { bookId }) => [{ type: 'Book', id: bookId }],
    }),
        
    getBookDetails: builder.query({
      query: ({ slug, isAdminSpace }) => ({
        url: `${BOOKS_URL}/slug/${slug}`, // Modification pour appeler l'API avec le slug
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, { bookId }) => [{ type: 'Book', id: bookId }],
    }),


    getBooksByAuthor: builder.query({
      query: (authorId) => ({
        url: `${BOOKS_URL}/author/${authorId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),
    
    getBooksByTranslator: builder.query({
      query: (authorId) => ({
        url: `${BOOKS_URL}/translator/${authorId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),
    
    getBooksByBooksCollection: builder.query({
      query: (booksCollectionId) => ({
        url: `${BOOKS_URL}/booksCollection/${booksCollectionId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),
    
    getThreeRandomBooksByBooksCollection: builder.query({
      query: (booksCollectionId) => ({
        url: `${BOOKS_URL}/booksCollection/${booksCollectionId}/random-books`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Books'],
    }),

    createBook: builder.mutation({
      query: (data) => ({
        url: `${BOOKS_URL}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Books'],
    }),
      
    updateBook: builder.mutation({
      query: (data) => ({
        //url: `${BOOKS_URL}/${data.bookId}`,
        url: `${BOOKS_URL}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Books'],
    }),

  deleteBook: builder.mutation({
    query: (bookId) => ({
      url: `${BOOKS_URL}/${bookId}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Books'],
  }),
    
    getTopBooks: builder.query({
      query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection }) => ({
        url: `${BOOKS_URL}/top`,
        params: { keyword, pageNumber, isAdminSpace, sortKey, sortDirection },
      }),


      // query: () => `${BOOKS_URL}/top`,
      // keepUnusedDataFor: 5,
    }),

    toggleBookVisibility: builder.mutation({
      query: (bookId) => ({
        url: `${BOOKS_URL}/${bookId}/visibility`,
        method: 'PUT',
      }),
      invalidatesTags: ['Books'], // Invalide le cache pour rafraîchir la liste
    }),    
  }),
});

export const {
  useGetBooksQuery,
  useGetBookListQuery,
  useGetBookDetailsQuery,
  useGetBookDetailsByIdQuery,
  useGetBooksByAuthorQuery,
  useGetBooksByTranslatorQuery,
  useGetBooksByBooksCollectionQuery,
  useGetThreeRandomBooksByBooksCollectionQuery,
  useCreateBookMutation,
  useUpdateBookMutation,
  useDeleteBookMutation,
  useGetTopBooksQuery,
  useToggleBookVisibilityMutation,
} = booksApiSlice;
